/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

 // Generated index.ts file.
export * from './site-depot-command.service';
export * from './timesheet-command.service';
export * from './staff-command.service';
export * from './scaffold-command.service';
export * from './off-hire-command.service';
export * from './handover-command.service';
export * from './dismantle-command.service';
export * from './variation-command.service';
export * from './site-command.service';
export * from './customer-command.service';
export * from './contract-command.service';
export * from './configuration-command.service';
